import { render } from "./ParentWrapper.vue?vue&type=template&id=d9c2a128"
const script = {}

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__